//System
import { Http, Headers, URLSearchParams, RequestOptions } from "@angular/http";
import { Injectable, Inject } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/of';
import 'rxjs/add/operator/do';
import 'rxjs/add/operator/share';

//Services
import { CacheService } from '../core/cache.service';
import { ApiService } from '../core/api.service';
import { LanguageService } from '../cms/language.service';
import { AuthService } from '../core/auth.service';
import { CookieService } from '../core/cookie/cookie.service';

//Models
import { Mappings } from '../../shared/mapping';
import { ClientAreaOrderDetails } from "./../../models/settings/client-area";
import { CartAddressModel } from "./../../models/core/cart";
import { CartProductModel } from "./../../models/core/cart";
import { CartInfo } from "./../../models/core/cart";
import { CurrencyService } from "../cms/currency.service";
import { AnonymousSubject } from "rxjs";

@Injectable()
export class ShoppingCartService {

  private cartId: number = 0;
  private cartData: any;

  constructor
    (
      public _api: ApiService,
      public _cache: CacheService,
      private mappings: Mappings,
      private authService: AuthService,
      private languageService: LanguageService,
      private currencyService: CurrencyService,
      @Inject('CookieService') private cookieService: CookieService
    ) { }

  // value of customizationData is set from canvas-widget component after editing is approved. After we can get that data inside of parent component and send it to a server
  private customizationData: any = null;
  private isProductCanvasEdited: boolean = false;

  saveCart(userId: string, cartId: number, paymentId: number, shipmentId: number) {

    let url = this.mappings.Web_Api_Get_Save_Cart.replace('{userId}', userId).replace('{cartId}', cartId.toString()).replace('{paymentId}', paymentId.toString()).replace('{shipmentId}', shipmentId.toString());
    let key = url;

    return this._api.get(url);
  }

  applyVoucher(voucherCode: string) {

    let customerId = this.getCustomerId();
    let cartId = this.getCartId();
    let lang = this.getLang();
    let curr = this.currencyService.getCurrency();

    let url = this.mappings.Web_Api_Set_Cart_Voucher;

    var param = {
      CartID: cartId,
      CustomerID: customerId,
      Voucher: voucherCode,
      Language: lang,
      Currency: curr
    }

    let key = url;

    return this._api.post(url, param);
  }

  setJobName(rowId: string, jobName: string) {

    let cartId = this.getCartId();
    let lang = this.getLang();

    let url = this.mappings.Web_Api_Set_Job_Name;

    var param = {
      CartID: cartId,
      ProductID: rowId,
      JobName: jobName
    }

    let key = url;

    return this._api.post(url, param);
  }

  setAddress(addressObject: any) {

    let cartId = this.getCartId();

    let url = this.mappings.Web_Api_Set_Cart_Address;

    var param = {
      CartID: cartId,
      AddressCity: addressObject.City,
      AddressID: addressObject.Id,
      AddressMobile: addressObject.Mobile,
      AddressPhone: addressObject.Phone,
      AddressPostalCode: addressObject.ZipCode,
      AddressProvince: addressObject.Province,
      AddressRecipient: addressObject.Recipient,
      AddressStreet: addressObject.Address,
      CustomerID: addressObject.CustomerID,
      Language: addressObject.Language
    }

    let key = url;

    return this._api.post(url, param);
  }

  confirmOrder() {

    let cartId = this.getCartId();
    let lang = this.getLang();

    var param = {
      CartID: cartId,
      Language: lang
    }

    let url = this.mappings.Web_Api_Post_Cart_Confirm_Order;

    return this._api.post(url, param);
  }

  clearCartAfterConfirmation() {
    this.cookieService.remove("cartId");
    this.cartData = new CartInfo();

    this.cartData.Products = [];
    this.cartData.Addresses = [];
    this.cartData.Payments = [];
    this.cartData.Shipments = [];
  }

  getCartPaymentShipment(cartId: number, lang: string) {
    let userId = this.getCustomerId();
    let curr = this.currencyService.getCurrency();

    let url = this.mappings.Web_Api_Get_Cart_Payment_Shipment.replace('{userId}', userId).replace('{cartId}', cartId.toString()).replace('{lang}', lang).replace('{currency}', curr);
    let key = url;

    return this._api.get(url);
  }

  addWizardCalcolatoToCart(wizardId: number, lavId: number) {
    let customerId = this.getCustomerId();
    let cartId = this.getCartId();
    let lang = this.getLang();
    let curr = this.currencyService.getCurrency();
    let canvasData = this.getIfProductIsCanvasEdited() ? this.getCustomizationCanvasData() : null;
    let isCanvasEdited = this.getIfProductIsCanvasEdited();

    let url = this.mappings.Web_Api_Add_Wizard_Calcolato_To_Cart;

    let key = url; let x = 0;

    let params = {
      CartID: cartId.toString(),
      CustomerID: customerId,
      Language: lang,
      ProductID: wizardId.toString(),
      LavID: lavId.toString(),
      Currency: curr,
      isCanvasEdited: isCanvasEdited,
      CanvasStateId: canvasData != null ? canvasData.stateId : null,
      CanvasHiResOutputUrls: canvasData != null ? canvasData.hiResOutputUrls : null
    }


    return this._api.post(url, params);
  }

  addApProductToCart(productId: number, lavId: number) {
    let customerId = this.getCustomerId();
    let cartId = this.getCartId();
    let lang = this.getLang();
    let curr = this.currencyService.getCurrency();

    let url = this.mappings.Web_Api_Add_Wizard_Calcolato_To_Cart;

    let key = url; let x = 0;

    let params = {
      CartID: cartId.toString(),
      CustomerID: customerId,
      Language: lang,
      ProductID: productId.toString(),
      LavID: lavId.toString(),
      Currency: curr
    }

    return this._api.post(url, params);
  }
  getRiorderCart() {
    let customerId = this.getCustomerId();
    let cartId = this.getCartId();
    let lang = this.getLang();
    let url = this.mappings.Web_Api_Get_Client_Area_Get_Cart_Riorder
      .replace('{userId}', customerId)
      .replace('{cartId}', cartId.toString())
      .replace('{lang}', lang);

    return this._api.get(url);
  }

  addWizardCalcolatoScontisticaToCart(wizardId: number, dateId: number, lavId: number) {
    let customerId = this.getCustomerId();
    let cartId = this.getCartId();
    let lang = this.getLang();
    let canvasData = this.getIfProductIsCanvasEdited() ? this.getCustomizationCanvasData() : null;
    let isCanvasEdited = this.getIfProductIsCanvasEdited();

    let url = this.mappings.Web_Api_Add_Wizard_Calcolato_Scontistica_To_Cart;

    let curr = this.currencyService.getCurrency();

    let key = url; let x = 0;

    let params = {
      CartID: cartId.toString(),
      CustomerID: customerId,
      Language: lang,
      ProductID: wizardId.toString(),
      LavID: lavId.toString(),
      DateID: dateId.toString(),
      Currency: curr,
      isCanvasEdited: isCanvasEdited,
      CanvasStateId: canvasData != null ? canvasData.stateId : null,
      CanvasHiResOutputUrls: canvasData != null ? canvasData.hiResOutputUrls : null
    }

    return this._api.post(url, params);
  }


  addWizardListinoToCart(wizardId: number, quantityId: number) {
    let customerId = this.getCustomerId();
    let cartId = this.getCartId();
    let lang = this.getLang();
    let url = this.mappings.Web_Api_Add_Wizard_Listino_To_Cart
    let curr = this.currencyService.getCurrency();

    let key = url; let x = 0;

    let params = {
      CartID: cartId.toString(),
      CustomerID: customerId,
      Language: lang,
      ProductID: wizardId.toString(),
      QuantityID: quantityId.toString(),
      Currency: curr
    }
    return this._api.post(url, params);
  }

  addOtherProductListinoToCart(combinationId: number, quantityId: number, wizardId: number) {
    let customerId = this.getCustomerId();
    let cartId = this.getCartId();
    let lang = this.getLang();
    let url = this.mappings.Web_Api_Add_Other_Product_Listino_To_Cart
    let curr = this.currencyService.getCurrency();

    let params = {
      CartID: cartId.toString(),
      CustomerID: customerId,
      Language: lang,
      ProductID: wizardId.toString(),
      QuantityID: quantityId.toString(),
      Currency: curr,
      CombinationId: combinationId.toString()
    }

    return this._api.post(url, params);
  }

  addOtherProductListinoScontisticaToCart(combinationId: number, quantityId: number, wizardId: number, dateId: number) {
    let customerId = this.getCustomerId();
    let cartId = this.getCartId();
    let lang = this.getLang();
    let url = this.mappings.Web_Api_Add_Other_Product_Listino_Scontistica_To_Cart
    let curr = this.currencyService.getCurrency();

    let params = {
      CartID: cartId.toString(),
      CustomerID: customerId,
      Language: lang,
      ProductID: wizardId.toString(),
      QuantityID: quantityId.toString(),
      Currency: curr,
      CombinationId: combinationId.toString(),
      DateID: dateId.toString()
    }

    return this._api.post(url, params);
  }

  addOtherProductCalcolatoListinoToCart(combinationId: number, quantityId: number, wizardId: number, strVariantiCalcolate: string) {
    let customerId = this.getCustomerId();
    let cartId = this.getCartId();
    let lang = this.getLang();
    let url = this.mappings.Web_Api_Add_Other_Product_Listino_Calcolato_To_Cart
    let curr = this.currencyService.getCurrency();

    let params = {
      CartID: cartId.toString(),
      CustomerID: customerId,
      Language: lang,
      ProductID: wizardId.toString(),
      QuantityID: quantityId.toString(),
      Currency: curr,
      CombinationId: combinationId.toString(),
      StrVariantiCalcolate: strVariantiCalcolate
    }

    return this._api.post(url, params);
  }

  addOtherProductCalcolatoListinoScontisticaToCart(combinationId: number, quantityId: number, wizardId: number, dateId: number, strVariantiCalcolate: string) {
    let customerId = this.getCustomerId();
    let cartId = this.getCartId();
    let lang = this.getLang();
    let url = this.mappings.Web_Api_Add_Other_Product_Listino_Calcolato_Scontistica_To_Cart
    let curr = this.currencyService.getCurrency();
    let params = {
      CartID: cartId.toString(),
      CustomerID: customerId,
      Language: lang,
      ProductID: wizardId.toString(),
      QuantityID: quantityId.toString(),
      Currency: curr,
      CombinationId: combinationId.toString(),
      DateID: dateId.toString(),
      StrVariantiCalcolate: strVariantiCalcolate,
    }

    return this._api.post(url, params);
  }

  addOtherProductCalcolatoScontisticaToCart(productId: number, lavId: number, dateId: number) {
    let customerId = this.getCustomerId();
    let cartId = this.getCartId();
    let lang = this.getLang();
    let curr = this.currencyService.getCurrency();

    let url = this.mappings.Web_Api_Add_Other_Product_Calcolato_Scontistica_To_Cart;

    let key = url; let x = 0;

    let params = {
      CartID: cartId.toString(),
      CustomerID: customerId,
      Language: lang,
      ProductID: productId.toString(),
      LavID: lavId.toString(),
      DateID: dateId.toString(),
      Currency: curr
    }

    return this._api.post(url, params);
  }

  addWizardListinoScontisticaBusteToCart(wizardId: number, quantityId: number, dateId: number, idPantoneFronte1: string, idPantoneFronte2: string, idPantoneRetro1: string, idPantoneRetro2: string) {
    let customerId = this.getCustomerId();
    let cartId = this.getCartId();
    let lang = this.getLang();
    let url = this.mappings.Web_Api_Add_Wizard_Buste_Listino_Buste_To_Cart
    let curr = this.currencyService.getCurrency();
    let canvasData = this.getIfProductIsCanvasEdited() ? this.getCustomizationCanvasData() : null;
    let isCanvasEdited = this.getIfProductIsCanvasEdited();

    let key = url; let x = 0;
    if (idPantoneFronte1 == null || idPantoneFronte1 == "") {
      idPantoneFronte1 = "0";
    }
    if (idPantoneFronte2 == null || idPantoneFronte2 == "") {
      idPantoneFronte2 = "0";
    }
    if (idPantoneRetro1 == null || idPantoneRetro1 == "") {
      idPantoneRetro1 = "0";
    }
    if (idPantoneRetro2 == null || idPantoneRetro2 == "") {
      idPantoneRetro2 = "0";
    }

    let params = {
      CartID: cartId.toString(),
      CustomerID: customerId,
      Language: lang,
      ProductID: wizardId.toString(),
      QuantityID: quantityId.toString(),
      DateID: dateId.toString(),
      IdPantoneFronte1: idPantoneFronte1.toString(),
      IdPantoneFronte2: idPantoneFronte2.toString(),
      IdPantoneRetro1: idPantoneRetro1.toString(),
      IdPantoneRetro2: idPantoneRetro2.toString(),
      Currency: curr,
      isCanvasEdited: isCanvasEdited,
      CanvasStateId: canvasData != null ? canvasData.stateId : null,
      CanvasHiResOutputUrls: canvasData != null ? canvasData.hiResOutputUrls : null
    }
    return this._api.post(url, params);
  }


  addWizardListinoBusteToCart(wizardId: number, quantityId: number, idPantoneFronte1: string, idPantoneFronte2: string, idPantoneRetro1: string, idPantoneRetro2: string) {
    let customerId = this.getCustomerId();
    let cartId = this.getCartId();
    let lang = this.getLang();
    let url = this.mappings.Web_Api_Add_Wizard_Buste_Listino_To_Cart
    let curr = this.currencyService.getCurrency();
    let canvasData = this.getIfProductIsCanvasEdited() ? this.getCustomizationCanvasData() : null;
    let isCanvasEdited = this.getIfProductIsCanvasEdited();

    let key = url; let x = 0;

    if (idPantoneFronte1 == null || idPantoneFronte1 == "") {
      idPantoneFronte1 = "0";
    }
    if (idPantoneFronte2 == null || idPantoneFronte2 == "") {
      idPantoneFronte2 = "0";
    }
    if (idPantoneRetro1 == null || idPantoneRetro1 == "") {
      idPantoneRetro1 = "0";
    }
    if (idPantoneRetro2 == null || idPantoneRetro2 == "") {
      idPantoneRetro2 = "0";
    }

    let params = {
      CartID: cartId.toString(),
      CustomerID: customerId,
      Language: lang,
      ProductID: wizardId.toString(),
      QuantityID: quantityId.toString(),
      IdPantoneFronte1: idPantoneFronte1.toString(),
      IdPantoneFronte2: idPantoneFronte2.toString(),
      IdPantoneRetro1: idPantoneRetro1.toString(),
      IdPantoneRetro2: idPantoneRetro2.toString(),
      Currency: curr,
      isCanvasEdited: isCanvasEdited,
      CanvasStateId: canvasData != null ? canvasData.stateId : null,
      CanvasHiResOutputUrls: canvasData != null ? canvasData.hiResOutputUrls : null
    }
    return this._api.post(url, params);
  }

  addWizardListinoScontisticaToCart(wizardId: number, quantityId: number, dateId: number) {
    let customerId = this.getCustomerId();
    let cartId = this.getCartId();
    let lang = this.getLang();
    let url = this.mappings.Web_Api_Add_Wizard_Listino_Scontistica_To_Cart
    let curr = this.currencyService.getCurrency();

    let key = url; let x = 0;

    let params = {
      CartID: cartId.toString(),
      CustomerID: customerId,
      Language: lang,
      ProductID: wizardId.toString(),
      QuantityID: quantityId.toString(),
      DateID: dateId.toString(),
      Currency: curr
    }
    return this._api.post(url, params);
  }


  addStaticProductToCart(productId: number, quantityId: number) {
    let customerId = this.getCustomerId();
    let cartId = this.getCartId();
    let lang = this.getLang();
    let curr = this.currencyService.getCurrency();

    let url = this.mappings.Web_Api_Add_Static_Product_To_Cart

    let key = url; let x = 0;

    let params = {
      CartID: cartId.toString(),
      CustomerID: customerId,
      Language: lang,
      ProductID: productId.toString(),
      QuantityID: quantityId.toString(),
      Currency: curr
    }

    return this._api.post(url, params);
  }

  addStaticProductScontisticaToCart(productId: number, quantityId: number, dateId: number) {

    let customerId = this.getCustomerId();
    let cartId = this.getCartId();
    let lang = this.getLang();
    let curr = this.currencyService.getCurrency();

    let url = this.mappings.Web_Api_Add_Static_Product_Scontistica_To_Cart

    let key = url; let x = 0;

    let params = {
      CartID: cartId.toString(),
      CustomerID: customerId,
      Language: lang,
      ProductID: productId.toString(),
      QuantityID: quantityId.toString(),
      DateID: dateId.toString(),
      Currency: curr
    }

    return this._api.post(url, params);
  }

  addMatrixProductToCart(productId: number, quantityId: number, type: string) {
    let customerId = this.getCustomerId();
    let cartId = this.getCartId();
    let lang = this.getLang();
    let curr = this.currencyService.getCurrency();

    let url = this.mappings.Web_Api_Add_Matrix_Product_To_Cart;

    let key = url; let x = 0;

    let params = {
      CartID: cartId.toString(),
      CustomerID: customerId,
      Language: lang,
      ProductID: productId.toString(),
      QuantityID: quantityId.toString(),
      Type: type,
      Currency: curr
    }

    return this._api.post(url, params);
  }

  getCartId(): string {
    //Reading cartId from cookie
    let cartId: string = this.cookieService.get("cartId");

    if (cartId == null || cartId == "") {
      cartId = "0";
    }

    return cartId;
  }

  setCartId(cartId: number) {
    this.cookieService.put("cartId", cartId.toString());
    this.cartId = cartId;
  }

  getCustomerId(): string {
    let userId = this.authService.GetUserId();

    return userId;
  }

  getLang(): string {
    let lang: string = this.languageService.getLongLang();

    return lang;
  }

  updateCart(cartData: any): void {
    let currentCartId: string = this.getCartId();

    if (currentCartId == "0") {
      this.setCartId(cartData.CartID);
    }

    //refreshing cart data
    this.cartData = cartData;
  }

  getCart() {
    return this.cartData;
  }

  initCart(cartData: any) {
    if (this.cartData == null) {
      this.cartData = cartData;
    }
  }

  setPayment(paymentId: string) {
    let customerId = this.getCustomerId();
    let cartId = this.getCartId();
    let lang = this.getLang();
    let curr = this.currencyService.getCurrency();

    let url = this.mappings.Web_Api_Set_Cart_Payment

    let key = url; let x = 0;

    let params = {
      CartID: cartId.toString(),
      PaymentID: paymentId,
      CustomerID: customerId,
      Language: lang,
      Currency: curr
    }

    return this._api.post(url, params);
  }

  setShipment(shipmentId: string) {
    let customerId = this.getCustomerId();
    let cartId = this.getCartId();
    let lang = this.getLang();
    let curr = this.currencyService.getCurrency();

    let url = this.mappings.Web_Api_Set_Cart_Shipment

    let key = url; let x = 0;

    let params = {
      CartID: cartId.toString(),
      ShippmentID: shipmentId,
      CustomerID: customerId,
      Language: lang,
      Currency: curr
    }

    return this._api.post(url, params);

  }

  removeFromCart(rowId: string) {
    let customerId = this.getCustomerId();
    let cartId = this.getCartId();
    let lang = this.getLang();
    let curr = this.currencyService.getCurrency();

    let url = this.mappings.Web_Api_Remove_From_Cart

    let key = url; let x = 0;

    let params = {
      CartID: cartId.toString(),
      ProductID: rowId,
      CustomerID: customerId.toString(),
      Language: lang,
      Currency: curr
    }

    return this._api.post(url, params);

  }

  //Check if the cart data is valid to access to the second step
  isCartValid() {
    let res: boolean = false;

    let cartId = this.getCartId();
    let customerId = this.getCustomerId();

    //Checking if user is logged-ing
    if (customerId != null && customerId != "" && customerId != "0") {
      //Checking if there is a cart set
      if (cartId != null && cartId != "" && cartId != "0") {
        //Checking if there are products
        if (this.cartData.Products != null && this.cartData.Products.length > 0) {
          //Checking if there is a payment set
          if (this.cartData.Payments != null && this.cartData.Payments.length > 0) {

            let flagPayment = false;

            for (let payment of this.cartData.Payments) {
              if (payment.Selected == true) {
                flagPayment = true;
                break;
              }
            }

            //Checking if there is a shipment set
            if (flagPayment == true) {

              if (this.cartData.Shipments != null && this.cartData.Shipments.length > 0) {

                let flagShipment = false;

                for (let shipment of this.cartData.Shipments) {
                  if (shipment.Selected == true) {
                    flagShipment = true;
                    break;
                  }
                }

                if (flagShipment == true) {
                  res = true;
                }
              }
            }
          }
        }
      }
    }
    return res;
  }
  addProductRiorderToCart(params: any) {
    let url = this.mappings.Web_Api_Get_Client_Area_Add_Product_To_Cart_Riorder

    let key = url; let x = 0;

    return this._api.post(url, params);
  }
  //Getting Empty cart page data
  getEmptyCartPageData() {
    let lang = this.getLang();
    let customerId = this.getCustomerId();
    let cartId = this.getCartId();

    let url = this.mappings.Web_Api_Empty_Cart_Page.replace("{lang}", lang).replace('{userid}', customerId).replace('{cartid}', cartId);

    return this._api.get(url);
  }

  setIfProductIsCanvasEdited(isEdited: boolean) {
    this.isProductCanvasEdited = isEdited;
  }

  getIfProductIsCanvasEdited() {
    return this.isProductCanvasEdited;
  }

  getCustomizationCanvasData() {
    return this.customizationData;
  }

  setCustomizationCanvasData(newData) {
    this.customizationData = newData;
  }

  // reset canvas state because of next adding to a cart
  resetCanvasData() {
    const emptyObj = {};
    this.setIfProductIsCanvasEdited(false);
    this.setCustomizationCanvasData(emptyObj);
  }
}


// WEBPACK FOOTER //
// ./src/../~/angular2-template-loader!./src/+app/services/inventory/shopping-cart.service.ts